module.exports = __webpack_public_path__ + "static/media/grin-wink.b852cb03.svg";